import React from "react";
import IdentityArrival from "./IdentityArrival";
export default function Login() { return <IdentityArrival mode="login" />; }
